'use es6';

import { createSelector } from 'reselect';
import { CURRENT_REVISION_ID } from 'DesignData/constants/Revisions';
import { TEMPLATE, CSS, JS, LAYOUT, GLOBAL_GROUP, GLOBAL_WIDGET, CUSTOM_WIDGET, RAW_ASSET } from 'DesignData/enums/DesignAssetTypes';
import { getFile } from 'DesignData/selectors/finder';
import { getTemplateBuffer } from 'DesignData/selectors/templateBuffers';
import { getLayout } from 'DesignData/selectors/layouts';
import { getGlobalWidget } from 'DesignData/selectors/globalWidgets';
import { makeGetCustomWidgetBuffer } from 'DesignData/selectors/customWidgetBuffers';
import { getRawAsset } from 'DesignData/selectors/rawAssetBuffers';
const getCustomWidgetBuffer = makeGetCustomWidgetBuffer();
export const getRevisions = (state, props) => state.revisions[props.revisionType].byId[props.assetId];
export const getFetchStatus = (state, props) => state.revisions[props.revisionType].fetchStatusById[props.assetId];

const getRevisionsDataById = (state, props) => state.revisions.byId[props.assetId];

export const getRevisionsData = createSelector([getRevisionsDataById], revisionsData => {
  if (!revisionsData) {
    return {};
  }

  const {
    order,
    revisions,
    fetchStatus,
    fetchError,
    total
  } = revisionsData;
  return {
    revisions: order.map(revisionId => revisions[revisionId]),
    order,
    fetchStatus,
    fetchError,
    total
  };
});
export const getIsUpgradedModule = createSelector([getFile, getRevisionsDataById], (file, revisionsData) => {
  if (file && file.designAssetType === CUSTOM_WIDGET && revisionsData) {
    const currentModuleRevision = revisionsData.revisions[CURRENT_REVISION_ID];
    return !!(currentModuleRevision && currentModuleRevision.object.schemaVersion > 1);
  }

  return false;
});
/**
 * Required props:
 *  - fileAssetType
 *  - assetId
 */

export const getBufferForRevision = (state, props) => {
  switch (props.fileAssetType) {
    case TEMPLATE:
    case CSS:
    case JS:
      return getTemplateBuffer(state, props);

    case LAYOUT:
    case GLOBAL_GROUP:
      return getLayout(state, props);

    case GLOBAL_WIDGET:
      return getGlobalWidget(state, props);

    case CUSTOM_WIDGET:
      return getCustomWidgetBuffer(state, props);

    case RAW_ASSET:
      return getRawAsset(state, props);

    default:
      {
        throw new TypeError(`Invalid file type for buffer. Received '${props.fileAssetType}'.`);
      }
  }
};